import { Failure } from '@mrhenry/failure';
import { html, TemplateResult } from 'lit';
import { live } from 'lit/directives/live.js';
import { classMap } from 'lit/directives/class-map.js';
import { Dispatcher } from '../../../types/booking-request';
import { staticText } from '../../../static-text';

export function fullNameInput(
	fullName: string,
	dispatch: Dispatcher,
	assetUrl: string,
	fullNameFailure?: Failure
): TemplateResult {
	const changeHandler = ( e: InputEvent ) => {
		if ( e.target !== e.currentTarget ) {
			return;
		}

		if ( !( e.target instanceof HTMLInputElement ) ) {
			throw new Error( 'e.target should be instanceof HTMLInputElement' );
		}

		const value = e.target.value;
		if ( !value || '' === value ) {
			dispatch( {
				type: 'UPDATE_FULL_NAME',
				fullName: value,
				fullNameFailure: Failure.from( staticText.fullNameIsRequiredFailureMessage ),
			} );

			return;
		}

		dispatch( {
			type: 'UPDATE_FULL_NAME',
			fullName: value,
		} );
	};

	const classes = {
		'has-error': Failure.isFailure( fullNameFailure ),
	};

	let failure = html``;
	if ( Failure.isFailure( fullNameFailure ) ) {
		failure = html`
			<p class="form__field-validation-error theme-color-error">
				<img alt="" class="form__field-validation-error__icon" src="${assetUrl}/assets/images/alert-circle.svg">
				${fullNameFailure?.message}
			</p>
		`;
	}

	return html`
		<div class="form__row ${classMap( classes )}">
			<div class="form__label-container type-d">
				<label class="form__label" for="full-name">
					${staticText.fullNameRequired}
				</label>
			</div>

			<input
				.value=${live( fullName )}
				@change=${changeHandler}
				class="form__input"
				id="full-name"
				name="full-name"
				type="text"
			/>

			${failure}
		</div>
	`;
}
